{
  "draft": {
    "restoreTitle": "Recover the draft from {{date}}?",
    "restoreHint": "This draft has not been sent yet. Attachments and photos are not kept in it: select them again if you need them.",
    "restore": "Recover",
    "discard": "Discard",
    "saveFailed": "Could not save the draft on this device.",
    "saveFailedHint": "What you typed is still on screen, but it has not been sent."
  },
  "update": {
    "available": "An update is available. You can update as soon as you finish.",
    "hintForm": "We will try to save your draft on this device first. Attachments not yet uploaded will need to be selected again.",
    "hintUpload": "An upload is in progress. If you update now it will be interrupted and the file will need to be selected again.",
    "manual": "An update is available. The automatic update did not work; tap Update to try again.",
    "now": "Update now",
    "manualButton": "Update",
    "applying": "Updating…",
    "saveFailedBody": "Could not save the draft on this device. If you update now, what you typed will be lost.",
    "anyway": "Update anyway",
    "keepEditing": "Keep editing",
    "chunkFailed": "This part of the app could not be loaded. Check your connection and try again.",
    "retry": "Try again"
  },
  "install": {
    "title": "Install Lumora",
    "intro": "You can add Lumora to your home screen to open it like an app. It works mainly online: it is not fully usable without internet.",
    "installed": "You are already using Lumora as an installed app.",
    "iphone": {
      "title": "iPhone (Safari)",
      "step1": "Open Lumora in Safari.",
      "step2": "Tap Share.",
      "step3": "Choose Add to Home Screen.",
      "step4": "Tap Add."
    },
    "android": {
      "title": "Android (Chrome)",
      "step1": "Open Lumora in Chrome.",
      "step2": "Open the menu (three dots).",
      "step3": "Tap Install app or Add to home screen.",
      "step4": "Confirm."
    },
    "desktop": {
      "title": "Computer (Chrome or Edge)",
      "step1": "Open Lumora in the browser.",
      "step2": "Click the install icon in the address bar, or open the menu and choose Install Lumora.",
      "step3": "Confirm."
    },
    "note": "When a new version is out, Lumora tells you and updates when it is safe. If the installed app looks outdated, close it and open it again."
  },
  "forms": {
    "warrantyReminderHint": "When checked, the reminder 30 days before the declared warranty end is active. We only remind you based on the date you declared."
  }
}
